import {
	OrderGroupResponse,
	RepeatOfferingInvestmentMetadata,
	RepeatOfferingInvestmentSelections,
	RepeatRiaInvestmentMetadata,
	RepeatRiaInvestmentSelections,
	RiaInvestTabAddFundsMetadata
} from 'types/add-funds';
import { currency } from '@filters/shared-filters';
import { investmentEntityRequest } from '@utils/request';

export async function getRepeatRiaInvestmentData(): Promise<RepeatRiaInvestmentMetadata> {
	const response = await investmentEntityRequest.get(`/repeat-investment/ria/metadata`);

	const repeatInvestmentData = response.data;

	const repeatRiaInvestmentMetadata: RepeatRiaInvestmentMetadata = {
		validRiaInvestmentRange: repeatInvestmentData.validRiaInvestmentRange,
		suggestedInvestmentAmounts: [],
		repeatRiaInvestmentSelections: repeatInvestmentData.repeatRiaInvestmentSelections,
		serviceLevelUpgradeMapping: repeatInvestmentData.serviceLevelUpgradeMapping
	};

	repeatRiaInvestmentMetadata.suggestedInvestmentAmounts = repeatInvestmentData.suggestedInvestmentAmounts.map(
		(suggestedInvestmentAmount: { amount: string; upgradeOption: boolean }) => {
			return {
				value: suggestedInvestmentAmount.amount,
				label: currency(suggestedInvestmentAmount.amount, 0) as string,
				sortIndex: suggestedInvestmentAmount.amount,
				upgradeOption: suggestedInvestmentAmount.upgradeOption
			};
		}
	);

	repeatRiaInvestmentMetadata.suggestedInvestmentAmounts.push({
		value: 'other',
		label: 'Other amount',
		sortIndex: 10000000,
		upgradeOption: false
	});

	return repeatRiaInvestmentMetadata;
}

export async function getInvestTabAddFundsData(): Promise<RiaInvestTabAddFundsMetadata> {
	const response = await investmentEntityRequest.get(`/invest/add-funds`);

	return response.data;
}

export async function getRepeatOfferingInvestmentData(
	offeringVintageId: string
): Promise<RepeatOfferingInvestmentMetadata> {
	const response = await investmentEntityRequest.get(`/repeat-investment/offering/${offeringVintageId}/metadata`);

	const repeatInvestmentData = response.data;

	const repeatReitInvestmentMetadata: RepeatOfferingInvestmentMetadata = {
		validReitInvestmentRange: repeatInvestmentData.validReitInvestmentRange,
		suggestedAchReitInvestmentAmounts: [],
		suggestedWireReitInvestmentAmounts: [],
		repeatOfferingInvestmentSelections: repeatInvestmentData.repeatReitInvestmentSelections,
		offeringName: repeatInvestmentData.offeringName,
		offeringId: repeatInvestmentData.offeringId,
		reitType: repeatInvestmentData.reitType,
		eligibleToInvestInOffering: repeatInvestmentData.eligibleToInvestInOffering
	};
	if (repeatInvestmentData.eligibleToInvestInOffering) {
		repeatReitInvestmentMetadata.suggestedAchReitInvestmentAmounts =
			repeatInvestmentData.suggestedAchReitInvestmentAmounts.map(
				(suggestedInvestmentAmount: { amount: string }) => {
					return {
						value: suggestedInvestmentAmount.amount,
						label: currency(suggestedInvestmentAmount.amount, 0) as string,
						sortIndex: suggestedInvestmentAmount.amount
					};
				}
			);

		repeatReitInvestmentMetadata.suggestedAchReitInvestmentAmounts?.push({
			value: 'other',
			label: 'Other amount',
			sortIndex: 10000000
		});

		repeatReitInvestmentMetadata.suggestedWireReitInvestmentAmounts =
			repeatInvestmentData.suggestedWireReitInvestmentAmounts.map(
				(suggestedInvestmentAmount: { amount: string }) => {
					return {
						value: suggestedInvestmentAmount.amount,
						label: currency(suggestedInvestmentAmount.amount, 0) as string,
						sortIndex: suggestedInvestmentAmount.amount
					};
				}
			);

		repeatReitInvestmentMetadata.suggestedWireReitInvestmentAmounts?.push({
			value: 'other',
			label: 'Other amount',
			sortIndex: 10000000
		});
	}
	return repeatReitInvestmentMetadata;
}

export async function getRepeatOfferingInvestmentSelectionData(): Promise<RepeatOfferingInvestmentSelections> {
	const response = await investmentEntityRequest.get(`/repeat-investment/offering/selections`);
	return response.data;
}

export const cacheRiaSelections = async (selections: RepeatRiaInvestmentSelections): Promise<void> => {
	await investmentEntityRequest.post(`/repeat-investment/ria/selections/save`, selections);
};

export const cacheOfferingSelections = async (selections: RepeatOfferingInvestmentSelections): Promise<void> => {
	await investmentEntityRequest.post(`/repeat-investment/offering/selections/save`, selections);
};

export const getOrderAllocation = async (amount: string, riaPlanId: string): Promise<OrderGroupResponse> => {
	const response = await investmentEntityRequest.get(`/investment/allocation`, {
		params: {
			amount: amount,
			riaPlanId: riaPlanId
		}
	});
	return response.data;
};
